module.exports = __webpack_public_path__ + "img/ctjl.da43c0fe.png";